import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { getDepartmentId, getTenantId } from 'src/app/services/store-snapshot.service';
import { environment } from 'src/environments/environment';
import {
  ICorrectiveActionRequest,
  ICorrectiveActionResponse,
} from '../models/corrective-action.model';
import { FormDataService } from '../../shared/attachments/service/form-data.service';

@Injectable({
  providedIn: 'root',
})
export class CorrectiveActionApiService {
  private readonly baseUrl = `${environment.apiUrl}/api`;

  private get url(): string {
    return `${this.baseUrl}/${getTenantId()}/${getDepartmentId()}/CorrectiveActions`;
  }

  constructor(private http: HttpClient) {}

  getCorrectiveActionById(id: string): Observable<ICorrectiveActionResponse> {
    const url = `${this.url}/${id}`;
    return this.http.get<ICorrectiveActionResponse>(url);
  }

  createCorrectiveAction(
    correctiveAction: ICorrectiveActionRequest
  ): Observable<ICorrectiveActionResponse> {
    const formData = FormDataService.mapToFormData(correctiveAction);
    return this.http.post<ICorrectiveActionResponse>(this.url, formData);
  }

  updateCorrectiveAction(
    correctiveAction: ICorrectiveActionRequest
  ): Observable<ICorrectiveActionResponse> {
    const formData = FormDataService.mapToFormData(correctiveAction);
    return this.http.put<ICorrectiveActionResponse>(this.url, formData);
  }

  deleteCorrectiveAction(id: string): Observable<void> {
    const url = `${this.url}/${id}`;
    return this.http.delete<void>(url);
  }

  printCorrectiveAction(id: string): Observable<Blob> {
    const url = `${this.url}/${id}/Print`;
    return this.http.get(url, { responseType: 'blob' });
  }
}
